import axios from 'axios';

// URL base según el entorno
const BASE_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:3002/api'
  : 'https://medicinpro.com/api';

console.log('Using API URL:', BASE_URL);

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Exportar BASE_URL
export { BASE_URL };

// Interceptor para manejar errores
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      console.error('API Error Response:', error.response.data);
    } else if (error.request) {
      console.error('API Error Request:', error.request);
    } else {
      console.error('API Error:', error.message);
    }
    throw error;
  }
);

export const getPlaces = async ({ stateSlug, citySlug, page = 1, search = '', specialty = 'ginecologos' }) => {
  console.log('getPlaces called with params:', { stateSlug, citySlug, page, search, specialty });
  
  // Usar el citySlug directamente sin formatear
  const url = `${BASE_URL}/places/${stateSlug}/${citySlug}`;
  
  console.log('Making request to:', url);
  console.log('With query params:', { page, search, specialty });

  try {
    const response = await api.get(url, {
      params: {
        page,
        search,
        specialty
      }
    });

    console.log('Response from API:', response.data);
    console.log('Places returned:', response.data.places?.map(p => ({ name: p.name, category: p.main_category })));

    return response.data;
  } catch (error) {
    console.error('API Error Response:', error.response?.data || error);
    throw error;
  }
};

export default api;